<template>
  <div class="exam-vault-container">
    <h1
      style="
        width: 100%;
        text-align: left;
        padding-bottom: 12px;
        display: flex;
        align-items: center;
      "
    >
      {{ $t('MENU_EXAM_VAULT') }}
    </h1>

    <el-tabs v-model="activeName" @tab-click="handleClickTab">
      <el-tab-pane
        v-if="ownerCategories !== 'Teacher'"
        :label="$t('ORG_GROUP')"
        name="Group"
        lazy
      >
        <ExamVaultCategory
          ref="groupCategory"
          ownerCategory="Group"
          :editable="true"
          :initialCategoryId="selectedCategoryId"
          @select-category="handleSelectCategory('Group', $event)"
          @editExam="handleEdit"
          @deleteExam="handleDelete"
          @assignHomework="handleAssignHomework"
          @createLesson="handleCreateLesson"
        />
      </el-tab-pane>

      <el-tab-pane
        v-if="ownerCategories === 'School'"
        :label="$t('SCHOOL')"
        name="School"
        lazy
      >
        <ExamVaultCategory
          ref="schoolCategory"
          ownerCategory="School"
          :editable="true"
          :initialCategoryId="selectedCategoryId"
          @select-category="handleSelectCategory('School', $event)"
          @editExam="handleEdit"
          @deleteExam="handleDelete"
          @assignHomework="handleAssignHomework"
          @createLesson="handleCreateLesson"
        />
      </el-tab-pane>

      <el-tab-pane
        v-if="ownerCategories === 'Teacher' || ownerCategories === 'School'"
        :label="$t('MENU_PROFILE')"
        name="Teacher"
        lazy
      >
        <ExamVaultCategory
          ref="teacherCategory"
          ownerCategory="Teacher"
          :editable="true"
          :initialCategoryId="selectedCategoryId"
          @select-category="handleSelectCategory('Teacher', $event)"
          @editExam="handleEdit"
          @deleteExam="handleDelete"
          @assignHomework="handleAssignHomework"
          @createLesson="handleCreateLesson"
        />
      </el-tab-pane>
    </el-tabs>

    <!-- Create Dialog -->
    <md-dialog :md-active.sync="examDialog.active">
      <md-dialog-title style="display: flex; justify-content: space-between">
        <div class="title">{{ $t('ADD_EXAM_VAULT') }}</div>
        <md-button
          class="md-icon-button"
          @click.prevent="examDialog.active = false"
        >
          <md-icon>close</md-icon>
        </md-button>
      </md-dialog-title>
      <md-dialog-content>
        <div class="input-field">
          <BaseInputQuestionText
            :placeholder="$t('COMMON_CODE')"
            :label="$t('COMMON_CODE')"
            :labelSize="14"
            v-model="examTemp.code"
          />
        </div>

        <div class="input-field">
          <BaseInputQuestionText
            :placeholder="$t('COMMON_TITLE')"
            :label="$t('COMMON_TITLE')"
            :labelSize="14"
            v-model="examTemp.title"
          />
        </div>

        <div class="input-field">
          <BaseInputQuestionTextArea
            :label="$t('COMMON_DESCRIPTION')"
            :labelSize="14"
            v-model="examTemp.description"
          />
        </div>

        <div class="input-field">
          <label style="font-size: 14px; display: block; margin-bottom: 8px">{{
            $t('CATEGORIES')
          }}</label>
          <treeselect
            v-model="examTemp.categoryIds"
            :multiple="true"
            :options="getCategories()"
            :normalizer="normalizeCategory"
            placeholder="Select categories"
            value-consists-of="BRANCH_PRIORITY"
          />
        </div>

        <div class="input-field">
          <BaseInputSelectV2
            :label="$t('SUBJECT')"
            :labelSize="14"
            :options="config.subjects"
            :optValue="`${lang}Value`"
            v-model="examTemp.subject"
          />
        </div>

        <div class="input-field">
          <BaseInputSelectV2
            :label="$t('TYPE')"
            :labelSize="14"
            :options="config.productTypes"
            :optValue="`${lang}Value`"
            v-model="examTemp.productType"
          />
        </div>

        <div class="input-field" v-if="isExerciseProductType">
          <BaseInputSelectV2
            label="Loại bài tập"
            :labelSize="14"
            :options="[
              { _id: 'normal', label: 'Câu hỏi' },
              { _id: 'video', label: 'Video' },
              { _id: 'vocabulary', label: 'Từ vựng' },
              { _id: 'conversation', label: 'Hội thoại' }
            ]"
            optValue="label"
            v-model="examTemp.type"
          />
        </div>

        <div v-if="examTemp.type === 'video' && isExerciseProductType" class="video-layout" style="margin-bottom: 24px; padding: 20px; background: #f9f9f9; border-radius: 8px;">
          <div class="video-header" style="color: #1cab36; font-weight: bold; font-size: 16px; margin-bottom: 14px;">
            Video
          </div>
          <el-row :gutter="24">
            <el-col :span="12">
              <div class="form-item" style="margin-bottom: 16px;">
                <label style="font-size: 14px; display: block; margin-bottom: 8px; font-weight: bold;">Nội dung hướng dẫn</label>
                <Tinymce
                  :key="examTemp._id || 'new'"
                  v-model="examTemp.content"
                  :height="300"
                />
              </div>
              <div class="form-item" style="margin-bottom: 16px;">
                <BaseInputText
                  placeholder="Video"
                  label="Video"
                  v-model="examTemp.videoUrl"
                />
              </div>
              <div class="form-item" style="margin-bottom: 16px;">
                <BaseInputFile
                  placeholder="Ảnh"
                  :labelSize="18"
                  label="Ảnh"
                  accept="image/*,.pdf,.doc,.docx"
                  v-model="examTemp.attachment"
                  :file="file.attachment"
                  :loading.sync="uploadLoading.attachment"
                  :progress.sync="uploadProgress.attachment"
                  :storageClass="config.storageClass"
                  iconClass="image"
                  @file-selected="(val) => handleVideoAttachmentUpload('attachment', val)"
                  @clear="clearVideoAttachment('attachment')"
                />
              </div>
            </el-col>
            <el-col :span="12">
              <div class="preview-area" style="background: white; padding: 15px; border-radius: 8px; height: 100%;">
                <div v-if="youtubeEmbedUrl(examTemp.videoUrl)" class="video-frame">
                  <iframe
                    :src="youtubeEmbedUrl(examTemp.videoUrl)"
                    frameborder="0"
                    allowfullscreen
                    style="width: 100%; height: 300px; border-radius: 8px;"
                  />
                </div>
                <div v-else-if="examTemp.videoUrl">
                  <a :href="examTemp.videoUrl" target="_blank" rel="noopener" style="color: #1cab36; word-break: break-all;">
                    {{ examTemp.videoUrl }}
                  </a>
                </div>
                <div v-if="examTemp.attachment" style="margin-top: 16px">
                  <img v-if="isImage(examTemp.attachment)" :src="examTemp.attachment | media" style="max-width: 100%; border-radius: 8px;" />
                  <a v-else :href="examTemp.attachment | media" target="_blank" style="color: #1cab36;">Xem tệp đính kèm</a>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div
          v-if="examTemp.subject === config.englishSubjectId"
          class="input-field"
        >
          <BaseInputSelectV2
            :label="$t('SKILL')"
            :labelSize="14"
            :options="config.skills"
            :optValue="`${lang}Value`"
            :clearable="true"
            v-model="examTemp.skill"
          />
        </div>

        <div class="input-field">
          <BaseInputSelectV2
            :label="$t('MAX_SCORE')"
            :labelSize="14"
            :options="maxScoreOptions"
            optValue="label"
            :clearable="true"
            v-model="examTemp.maxScore"
          />
        </div>

        <!-- <div class="input-field">
          <BaseInputSelectV2
            :label="$t('COMMON_TAGS')"
            :labelSize="14"
            :filterable="true"
            :allowCreate="true"
            v-model="examTemp.tags"
            :createTag="true"
            multiple
          />
        </div> -->

        <div class="btn-block">
          <md-button
            class="md-raised"
            @click.prevent="examDialog.active = false"
          >
            {{ $t('CANCEL') }}
          </md-button>
          <md-button
            class="md-raised md-primary text-white"
            @click.prevent="handleUpdateExam"
          >
            {{ examDialog.type === 'create' ? $t('CREATE') : $t('UPDATE') }}
          </md-button>
        </div>
      </md-dialog-content>
    </md-dialog>

    <!-- Create Homework Dialog -->
    <AssignHomeworkDialog
      :active.sync="hwDialog.active"
      :exam="hwDialog.exam"
      @success="handleAssignHomeworkSuccess"
    />

    <!-- Create Lesson Dialog -->
    <md-dialog :md-active.sync="lessonDialog.active">
      <md-dialog-title style="display: flex; justify-content: space-between">
        <div class="title">{{ $t('CREATE_LESSON') }}</div>
        <md-button
          class="md-icon-button"
          @click.prevent="lessonDialog.active = false"
        >
          <md-icon>close</md-icon>
        </md-button>
      </md-dialog-title>
      <md-dialog-content>
        <div class="input-field">
          <BaseInputText
            :placeholder="$t('SORT_INDEX')"
            :label="$t('SORT_INDEX')"
            :labelSize="14"
            type="number"
            v-model="lessonTemp.sortIndex"
          />
        </div>

        <div class="input-field">
          <BaseInputSelectV2
            :label="$t('CLASS')"
            :labelSize="14"
            :options="classes"
            :optValue="'name'"
            :filterable="true"
            v-model="lessonTemp.classId"
          />
        </div>

        <div class="btn-block">
          <md-button
            class="md-raised"
            @click.prevent="lessonDialog.active = false"
          >
            {{ $t('CANCEL') }}
          </md-button>
          <md-button
            class="md-raised md-primary text-white"
            @click.prevent="createLesson"
          >
            {{ $t('CREATE') }}
          </md-button>
        </div>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
// import _ from 'lodash'
import { mapState } from 'vuex'
import ExamVaultCategory from './components/ExamCategory.vue'
import AssignHomeworkDialog from './components/AssignHomeworkDialog.vue'
import examVaultApi from '@/api/exam-vault'
import Treeselect from '@riophae/vue-treeselect'
import Tinymce from '@/components/Tinymce'
// import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'ExamVaultList',
  components: {
    ExamVaultCategory,
    Treeselect,
    AssignHomeworkDialog,
    Tinymce
  },

  data() {
    return {
      activeName: 'Group',
      selectedSubject: null,
      selectedCategoryId: null,
      selectedProductType: null,
      selectedSkill: null,
      searchQuery: '',
      examDialog: {
        active: false,
        type: 'create'
      },
      hwDialog: {
        active: false,
        exam: null
      },
      hwTemp: {},
      lessonDialog: {
        active: false,
        exam: null
      },
      lessonTemp: {},
      examTemp: {
        categoryIds: []
      },
      lang: 'vi',
      maxScoreOptions: [25, 50, 100, 150, 200].map((v) => ({ _id: v, label: String(v) })),
      defaultMaxScore: 100,
      uploadLoading: { attachment: false },
      uploadProgress: { attachment: 0 },
      file: { attachment: null }
    }
  },

  computed: {
    ...mapState('exam-vault', ['accessLevel', 'exams', 'config']),
    ...mapState('content', ['classes', 'students']),
    ...mapState('user', ['orgCategory', 'profile']),
    ownerCategories() {
      if (this.orgCategory === 'school') {
        return 'School'
      } else if (this.orgCategory === 'group') {
        return 'Group'
      } else {
        return 'Teacher'
      }
    },
    isExerciseProductType() {
      if (!this.examTemp.productType || !this.config.productTypes) return false
      const productType = this.config.productTypes.find((pt) => pt._id === this.examTemp.productType)
      return productType && (productType.enValue === 'Exercise' || productType.viValue === 'Bài tập')
    }
  },

  created() {
    this.lang = this.$i18n.locale
    this.$store.dispatch('content/getClasses', {
      teacherId: this.profile._id,
      status: 'open',
      contestClass: false,
      page: 1,
      limit: 500
    })

    // Restore tab and category from URL query parameters
    if (this.$route.query.tab) {
      this.activeName = this.$route.query.tab
    }
    if (this.$route.query.categoryId) {
      this.selectedCategoryId = this.$route.query.categoryId
    }
  },

  watch: {
    activeName(newTab) {
      // Update URL query parameter when tab changes
      this.$router
        .replace({
          query: {
            ...this.$route.query,
            tab: newTab
          }
        })
        .catch(() => {})
    },

    selectedCategoryId(newCategoryId) {
      // Update URL query parameter when category changes
      if (newCategoryId && newCategoryId !== this.$route.query.categoryId) {
        this.$router
          .replace({
            query: {
              ...this.$route.query,
              categoryId: newCategoryId
            }
          })
          .catch(() => {})
      }
    }
  },

  methods: {
    handleAssignHomework(exam) {
      this.hwDialog = {
        active: true,
        exam
      }
    },

    handleAssignHomeworkSuccess() {
      this.$notify({
        type: 'success',
        title: this.$t('M_TITLE_SUCCESS'),
        message: this.$t('M_EXER_CREATE_SUCCESS')
      })
    },

    handleCreateLesson(exam) {
      this.lessonTemp = {
        classId: null,
        sortIndex: 1
      }
      this.lessonDialog = {
        active: true,
        exam
      }
    },

    async createLesson() {
      try {
        const examVaultId = this.lessonDialog.exam._id
        await examVaultApi.createLessonForClass(examVaultId, this.lessonTemp)
        this.lessonDialog.active = false
        this.lessonDialog.exam = null

        this.$notify({
          type: 'success',
          title: this.$t('M_TITLE_SUCCESS'),
          message: this.$t('M_LESSON_CREATE_SUCCESS')
        })
      } catch (error) {
        this.$notify({
          type: 'error',
          title: this.$t('M_TITLE_ERROR'),
          message: error.message || this.$t('M_LESSON_CREATE_ERROR')
        })
      }
    },

    handleSelectCategory(tabName, categoryId) {
      if (this.selectedCategoryId === categoryId) {
        return
      }

      this.selectedCategoryId = categoryId
    },

    handleClickTab(tab) {
      this.activeName = tab.name
    },

    // Refresh the active exam component based on the current tab
    refreshActiveExamComponent() {
      const refMap = {
        Teacher: 'teacherCategory',
        School: 'schoolCategory',
        Group: 'groupCategory'
      }

      const refName = refMap[this.activeName]
      if (this.$refs[refName]) {
        this.$refs[refName].refreshExams()
      }
    },

    getCategories() {
      const refMap = {
        Teacher: 'teacherCategory',
        School: 'schoolCategory',
        Group: 'groupCategory'
      }

      const refName = refMap[this.activeName]
      if (this.$refs[refName] && this.$refs[refName].categories) {
        return this.$refs[refName].categories
      }
      return []
    },

    normalizeCategory(node) {
      return {
        id: node._id || node.id,
        label: node.name,
        children: node.children
      }
    },

    handleAddVocabularyItem() {
      this.$prompt('Nhập từ vựng mới (Định dạng: Từ | Nghĩa | IPA | Loại từ)', 'Thêm từ vựng', {
        confirmButtonText: 'Thêm',
        cancelButtonText: 'Hủy',
        inputPlaceholder: 'Ví dụ: Apple | Quả táo | æp.əl | noun'
      }).then(({ value }) => {
        if (!value) return
        const parts = value.split('|').map(s => s.trim())
        const word = parts[0] || ''
        const meaning = parts[1] || ''
        const ipa = parts[2] || ''
        const type = parts[3] || ''
        if (!word) return
        if (!this.examTemp.vocabularies) {
          this.$set(this.examTemp, 'vocabularies', [])
        }
        this.examTemp.vocabularies.push({
          word,
          meaning,
          englishMean: meaning,
          ipa,
          type,
          assessmentEngine: 'wav2vec2'
        })
      }).catch(() => {})
    },

    handleRemoveVocabularyItem(index) {
      if (this.examTemp.vocabularies) {
        this.examTemp.vocabularies.splice(index, 1)
      }
    },

    handleAddConversationItem() {
      this.$prompt('Nhập lượt thoại mới (Định dạng: Người nói (A/B) | Câu thoại | Nghĩa)', 'Thêm lượt thoại', {
        confirmButtonText: 'Thêm',
        cancelButtonText: 'Hủy',
        inputPlaceholder: 'Ví dụ: A | Hello, how are you? | Xin chào, bạn khỏe không?'
      }).then(({ value }) => {
        if (!value) return
        const parts = value.split('|').map(s => s.trim())
        const user = (parts[0] || 'A').toUpperCase() === 'B' ? 'B' : 'A'
        const phrase = parts[1] || ''
        const meaning = parts[2] || ''
        if (!phrase) return
        if (!this.examTemp.conversations) {
          this.$set(this.examTemp, 'conversations', [])
        }
        const item = {
          user,
          assessmentEngine: 'wav2vec2'
        }
        item[user] = [{ phrase, meaning }]
        this.examTemp.conversations.push(item)
      }).catch(() => {})
    },

    handleRemoveConversationItem(index) {
      if (this.examTemp.conversations) {
        this.examTemp.conversations.splice(index, 1)
      }
    },

    handleEdit(event, data) {
      if (event === 'create') {
        this.examTemp = {
          code: '',
          title: '',
          type: 'normal',
          description: '',
          tags: [],
          subject: null,
          productType: null,
          skill: null,
          videoUrl: '',
          attachment: null,
          content: '',
          vocabularies: [],
          conversations: [],
          maxScore: this.defaultMaxScore,
          categoryIds: [this.selectedCategoryId]
        }
      } else if (event === 'update') {
        this.examTemp = {
          _id: data._id,
          code: data.code,
          title: data.title,
          type: data.type || 'normal',
          description: data.description,
          tags: data.tags,
          subject: data?.subject?._id,
          productType: data?.productType?._id,
          skill: data?.skill?._id,
          videoUrl: data.videoUrl || '',
          attachment: data.attachment || null,
          content: data.content || '',
          vocabularies: data.vocabularies || [],
          conversations: data.conversations || [],
          maxScore: data.maxScore ?? this.defaultMaxScore,
          categoryIds: data.categoryIds
        }
      }

      this.examDialog.active = true
      this.examDialog.type = event
    },

    async handleDelete(data) {
      await this.$store.dispatch('exam-vault/deleteExam', data._id)
      // Refresh the active exam component
      this.refreshActiveExamComponent()
    },

    async handleUpdateExam() {
      try {
        if (this.examDialog.type === 'create') {
          const res = await this.$store.dispatch('exam-vault/createExam', {
            ...this.examTemp,
            ownerCategory: this.activeName
          })

          let examVaultId = null
          if (res && res.data) {
            examVaultId = res.data.examVault ? res.data.examVault._id : res.data._id
          }

          if (this.file.attachment instanceof File && examVaultId) {
            this.$set(this.uploadLoading, 'attachment', true)
            try {
              const uploadRes = await examVaultApi.uploadAttachment(
                { examVaultId: examVaultId, file: this.file.attachment },
                (progressEvent) => {
                  this.uploadProgress.attachment = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                }
              )
              const attachmentKey = '/' + uploadRes.data.key
              await this.$store.dispatch('exam-vault/updateExam', {
                _id: examVaultId,
                attachment: attachmentKey
              })
              this.$set(this.examTemp, 'attachment', attachmentKey)
              this.$set(this.file, 'attachment', uploadRes.data.key)
            } catch (uploadErr) {
              console.error(uploadErr)
              this.$notify({ type: 'error', title: 'Lỗi', message: 'Tải tệp đính kèm thất bại' })
            }
            this.$set(this.uploadLoading, 'attachment', false)
          }

          this.examDialog.active = false
          // Refresh the active exam component
          this.refreshActiveExamComponent()
        } else {
          await this.$store.dispatch('exam-vault/updateExam', {
            ...this.examTemp,
            ownerCategory: this.activeName
          })

          if (this.file.attachment instanceof File) {
            this.$set(this.uploadLoading, 'attachment', true)
            try {
              const uploadRes = await examVaultApi.uploadAttachment(
                { examVaultId: this.examTemp._id, file: this.file.attachment },
                (progressEvent) => {
                  this.uploadProgress.attachment = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                }
              )
              const attachmentKey = '/' + uploadRes.data.key
              await this.$store.dispatch('exam-vault/updateExam', {
                _id: this.examTemp._id,
                attachment: attachmentKey
              })
              this.$set(this.examTemp, 'attachment', attachmentKey)
              this.$set(this.file, 'attachment', uploadRes.data.key)
            } catch (uploadErr) {
              console.error(uploadErr)
              this.$notify({ type: 'error', title: 'Lỗi', message: 'Tải tệp đính kèm thất bại' })
            }
            this.$set(this.uploadLoading, 'attachment', false)
          }

          this.examDialog.active = false
          // Refresh the active exam component
          this.refreshActiveExamComponent()
        }
      } catch (error) {
        // console.error('Error during exam update:', error)
      }
    },
    youtubeEmbedUrl(url) {
      if (!url) return null
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
      const match = url.match(regExp)
      return (match && match[2].length === 11)
        ? 'https://www.youtube.com/embed/' + match[2]
        : null
    },
    isImage(url) {
      if (!url) return false
      return url.match(/\.(jpeg|jpg|gif|png)$/i) != null
    },
    async handleVideoAttachmentUpload(field, e) {
      if (!e || e.length === 0) return
      const file = e[0]

      // Nếu đang UPDATE (đã có _id), upload ngay
      if (this.examTemp._id) {
        this.$set(this.uploadLoading, field, true)
        try {
          const response = await examVaultApi.uploadAttachment(
            { examVaultId: this.examTemp._id, file },
            (progressEvent) => {
              this.$set(
                this.uploadProgress,
                field,
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              )
            }
          )
          this.$set(this.examTemp, field, '/' + response.data.key)
          this.$set(this.file, field, response.data.key)
        } catch (err) {
          console.error(err)
          this.$notify({ type: 'error', title: 'Lỗi', message: 'Tải tệp đính kèm thất bại' })
        }
        this.$set(this.uploadLoading, field, false)
      } else {
        // Đang CREATE: lưu file tạm, upload sau khi lưu bản ghi
        this.file[field] = file
        this.$set(this.examTemp, field, URL.createObjectURL(file))
      }
    },
    clearVideoAttachment(field) {
      this.file[field] = null
      this.$set(this.examTemp, field, null)
    }
  }
}
</script>

<style scoped lang="scss">
.exam-vault-container {
  padding: 24px;
  min-height: 100vh;

  .top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .filters-section {
      display: flex;
      width: 100%;
      justify-content: flex-start;
      flex-wrap: wrap;

      .search-box {
        min-width: 250px;
      }

      .filter-control {
        margin-right: 10px;
      }
    }
  }

  .error-state,
  .empty-state {
    text-align: center;
    padding: 50px;
  }

  .exams-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
  }

  .exam-card {
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 15px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .exam-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  .exam-meta {
    margin: 10px 0;
  }

  .badge {
    margin-right: 5px;
  }

  .tags-container {
    margin-top: 10px;
  }

  .tag {
    background-color: #e9ecef;
    border-radius: 15px;
    padding: 2px 8px;
    font-size: 12px;
    margin-right: 5px;
    display: inline-block;
    margin-bottom: 5px;
  }

  .card-actions {
    margin-top: 15px;
    text-align: right;
  }
}

.input-field {
  margin-bottom: 15px;
}
</style>
